import { updatePlanningInboxTableRows } from '@/entities/gridTables/thunks/updatePlanningInboxTableRows'
import { OLMSApiService } from '@/shared/apis'
import { ThunkApiContext } from '@/shared/store'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { Order } from '../models/Order'
import { replaceAllOrders } from '../ordersSlice'

export const cleanUpInbox = createAsyncThunk<number | undefined, void, ThunkApiContext>('orders/cleanUpInbox', async (_, { dispatch }) => {
  await OLMSApiService.get<Order>('/planning/cleanUpInbox')

  const orders = await OLMSApiService.post<Order[]>('/planning/orders', [])

  if (!orders || orders.length === 0) return 0
  
  dispatch(replaceAllOrders(orders))
  dispatch(updatePlanningInboxTableRows())

  return orders.length
})
